// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__28hkV","footer":"ModalUpdate_footer__2wdA5"};